import { createContext, useContext, Dispatch } from 'react';
import { defaultUser } from './CreateMultipleUserReducer';
import { CreateMultipleUserAction, CreateMultipleUserState } from './types';

export const defaultState: CreateMultipleUserState = {
    users: [defaultUser, defaultUser],
    shouldSendEmail: true,
    isDirty: false,
};

type CreateMultipleUserDispatchContextType = Dispatch<CreateMultipleUserAction>;

export const CreateMultipleUserContext =
    createContext<CreateMultipleUserState>(defaultState);

export const CreateMultipleUserDispatchContext =
    createContext<CreateMultipleUserDispatchContextType>(() => {});

export const useCreateMultipleUserContext = () =>
    useContext(CreateMultipleUserContext);
export const useCreateMultipleUserDispatchContext = () =>
    useContext(CreateMultipleUserDispatchContext);
